// Utility function to sanitize file names
export function sanitizeFileName(fileName: string): string {
  // Remove any path information
  const name = fileName.split(/[\/\\]/).pop() || fileName;
  
  // Get the file extension
  const ext = name.split('.').pop()?.toLowerCase() || '';
  
  // Get the base name without extension
  const baseName = name.slice(0, -(ext.length + 1));
  
  // Replace any non-alphanumeric characters (except hyphens and underscores) with hyphens
  const cleanName = baseName
    .replace(/[^a-z0-9-_]/gi, '-') // Replace invalid chars with hyphens
    .replace(/-+/g, '-')           // Replace multiple hyphens with single hyphen
    .replace(/^-+|-+$/g, '')       // Remove leading/trailing hyphens
    .toLowerCase();                 // Convert to lowercase
    
  // Ensure the name isn't empty and add the extension back
  return `${cleanName || 'video'}.${ext}`;
}